<!-- static content data from lang: visitor_request -->
<template>
    <div>
        <div id='printVisitor' class="h-100" v-loading="loading">
            <template v-if="errored">
                <div class="page-not">
                    <Notfound />
                </div>
            </template>
            <template v-else>
                <base-header class="pb-6">
                    <div class="row align-items-center pb-4">
                        <div class="col-lg-12 col-12">
                            <h6 class="h2 text-white d-inline-block mb-0">{{ lang.label.addHeaderTitle }}</h6>
                            <nav aria-label="breadcrumb" class="d-inline-block ml-4">
                                <route-bread-crumb></route-bread-crumb>
                            </nav>
                        </div>
                    </div>
                </base-header>
                <div class="container-fluid mt--6">
                    <div>
                        <card class="no-border-card mb-0" footer-classes="pb-2">
                            <div class="row">
                                <div class="col-md-12 text-right mb-3" data-html2canvas-ignore="true">
                                    <button class="btn btn-primary do-not-print" @click="printWindow()"><i
                                            class="fa fa-print mr-2"></i>Print</button>
                                    <ExportView class="btn btn-info do-not-print" dom="#printVisitor"
                                        name="visitor.pdf" />
                                </div>
                                <div class="col-md-12">
                                    <template v-for="(message) in alertMessages">
                                        <Alert :key="message" :type=alertType dismissible v-if="message"> <span
                                                class="alert-inner--text">{{ message }} </span> <button type="button"
                                                class="close" data-dismiss="alert" aria-label="Close"> <span
                                                    aria-hidden="true">&times;</span> </button> </Alert>
                                    </template>
                                    <template v-for="(message) in successMessages">
                                        <Alert :key="message" :type=successType dismissible v-if="message"> <span
                                                class="alert-inner--text">{{ message }} </span> <button type="button"
                                                class="close" data-dismiss="alert" aria-label="Close"> <span
                                                    aria-hidden="true">&times;</span> </button> </Alert>
                                    </template>
                                    <div class="request-detail">
                                        <div class="row">
                                            <div class="col-sm-6 col-md-3">
                                                <div class="form-group">
                                                    <h3 class="d-block form-control-label mb-0 font-weight-700">
                                                        {{ lang.label.siteName }}:</h3>
                                                    <span class="d-block form-control-label font-weight-500">
                                                        {{ (data.SiteName != '' ? data.SiteName :
                                                            lang.label.noData) }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-3">
                                                <div class="form-group">
                                                    <h3 class="d-block form-control-label mb-0 font-weight-700">
                                                        {{ lang.label.visitorName }}:</h3>
                                                    <span class="d-block form-control-label font-weight-500">{{
                                                        (data.VisitorName !=
                                                            '' ? data.VisitorName :
                                                        lang.label.noData)}}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-3">
                                                <div class="form-group">
                                                    <h3 class="d-block form-control-label mb-0 font-weight-700">
                                                        {{ lang.label.vistitorSurname }}:</h3>
                                                    <span class="d-block form-control-label font-weight-500">{{
                                                        (data.surname
                                                            != '' ? data.surname
                                                        :lang.label.noData)}}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-3">
                                                <div class="form-group">
                                                    <h3 class="d-block form-control-label mb-0 font-weight-700">
                                                        {{ lang.label.idPassport }}:</h3>
                                                    <span class="d-block form-control-label font-weight-500">{{
                                                        (data.visitor_id
                                                            != '' ? data.visitor_id
                                                        :lang.label.noData)}}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-6 col-md-3">
                                                <div class="form-group">
                                                    <h3 class="d-block form-control-label mb-0 font-weight-700">
                                                        {{ lang.label.mobileNo }}:</h3>
                                                    <span class="d-block form-control-label font-weight-500">{{
                                                        (data.visitor_mobile
                                                            != '' ?
                                                        data.visitor_mobile :lang.label.noData)}}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-3">
                                                <div class="form-group">
                                                    <h3 class="d-block form-control-label mb-0 font-weight-700">
                                                        {{ lang.label.accessDate }}:</h3>
                                                    <span class="d-block form-control-label font-weight-500"> {{ (
                                                        data.AccessRequestDateFrom != '' ?
                                                            (data.AccessRequestDateFrom) : lang.label.noData) }} &nbsp;-
                                                        &nbsp;{{ (data.AccessRequestDateTo !=
                                                            '' ? (data.AccessRequestDateTo) : lang.label.noData) }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-3">
                                                <div class="form-group">
                                                    <h3 class="d-block form-control-label mb-0 font-weight-700">
                                                        {{ lang.label.hostUserName }}:</h3>
                                                    <span class="d-block form-control-label font-weight-500">{{
                                                        (data.department.name
                                                            != '' ? data.department.name :
                                                        lang.label.noData)}}</span>
                                                </div>
                                            </div>


                                            <div class="col-sm-6 col-md-3">
                                                <div class="form-group">
                                                    <h3 class="d-block form-control-label mb-0 font-weight-700">
                                                        {{ lang.label.status }}:</h3>
                                                    <span class="d-block form-control-label font-weight-500">{{
                                                        (data.Status
                                                            != '' ? data.Status
                                                        :lang.label.noData)}}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-6 col-md-3">
                                                <div class="form-group">
                                                    <h3 class="d-block form-control-label mb-0 font-weight-700">
                                                        {{ lang.label.approvedBy }}:</h3>
                                                    <span class="d-block form-control-label font-weight-500">{{
                                                        (data.approved_by
                                                            ?
                                                        data.approved_by :lang.label.noData)}}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-3">
                                                <div class="form-group">
                                                    <h3 class="d-block form-control-label mb-0 font-weight-700">
                                                        {{ lang.label.visitorRemarks }}:</h3>
                                                    <span class="d-block form-control-label font-weight-500">{{
                                                        (data.VisitorRemarks
                                                            != '' ?
                                                        data.VisitorRemarks :lang.label.noData)}}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="form-group col-sm-3 col-md-3">
                                                        <h3 class="d-block form-control-label font-weight-700"
                                                            v-if="questionAnswers != ''">
                                                            {{ lang.label.questions }}</h3>
                                                        <div class="form-group question-list"
                                                            v-for="(que, index) in questionAnswers" :key="index">
                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="form-control-label">
                                                                        <badge type="default" class="que-count">{{ index
                                                                            +
                                                                            1}}</badge>
                                                                        <span
                                                                            v-html=que.CompanyQuestionnaireQuestionName></span>
                                                                        <span class="d-block mt-1">Answer:
                                                                            <strong>{{ que.QuestionAnswerBoolean
                                                                                }}</strong></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="html2pdf__page-break" v-if="index >= 7"></div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6 col-md-6">
                                                        <h3 class="d-block form-control-label mb-3 font-weight-700">{{
                                                            lang.label.documents }}:</h3>
                                                        <div class="documents-container">
                                                            <div v-for="(doc, index) in data.documents" :key="index"
                                                                class="document-item">
                                                                <el-tooltip content="View Document" placement="bottom">

                                                                <div class="document-card"
                                                                    @click="openDocument(doc.document)">

                                                                    <div class="document-icon">

                                                                        <i class="fas fa-file-alt"></i>
                                                                    </div>
                                                                    <div class="document-details">
                                                                        <div class="document-name">
                                                                            {{ doc.document_name ||
                                                                            doc.document_type.name }}
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                                </el-tooltip>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--<div class="html2pdf__page-break"></div>-->
                                            <div class="col-md-12" v-if="approved">
                                                <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                                                    <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                                                        <base-input :label="lang.label.siteRemarks + ':'"
                                                            name="Site Remarks"
                                                            labelClasses="form-control-label font-weight-700">
                                                            <textarea class="form-control"
                                                                id="exampleFormControlTextarea3"
                                                                ref="exampleFormControlTextarea3" rows="3"
                                                                v-model="siteRemarks" autocomplete="off">
                        </textarea>
                                                        </base-input>
                                                    </form>
                                                </validation-observer>
                                            </div>
                                            <!-- <div class="col-md-12">
                                          <div class="form-group">
                                            <h3 class="d-block form-control-label mb-0 font-weight-700">{{lang.label.action}}:</h3>
                                            <b-form-group>
                                            <b-form-radio-group
                                              id="radio-group"
                                              v-model="model.selected"
                                              autocomplete="off"
                                              :options="actions"
                                              name="radio-options"
                                            ></b-form-radio-group>
                                          </b-form-group>
                                          </div>
                                        </div> -->
                                            <div class="col-md-12 text-right mb-3" v-if="approved">
                                                <base-button type="primary" native-type="submit"
                                                    @click="modalVisible = true">Reroute</base-button>
                                                <base-button type="primary" native-type="submit"
                                                    @click="onSubmit(11)">{{ lang.label.buttons.accept
                                                    }}</base-button>
                                                <base-button type="danger" native-type="submit"
                                                    @click="rejectModalVisible = true">{{
                                                    lang.label.buttons.decline }}</base-button>
                                            </div>
                                            <div class="col-md-12" v-if="groupName">
                                                <div class="form-group">
                                                    <h3 class="d-block form-control-label mb-0 font-weight-700">
                                                        {{ lang.label.groupName }}:</h3>
                                                    <span class="d-block form-control-label font-weight-500">{{
                                                        groupName }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-12" v-if="tableData.length">
                                                <el-table :data="queriedData" row-key="id"
                                                    header-row-class-name="thead-light" @sort-change="sortChange"
                                                    border>
                                                    <el-table-column label="Member Name" sortable prop="MemberName">
                                                        <div class="d-flex" slot-scope="scope"
                                                            v-html="scope.row.MemberName"></div>
                                                    </el-table-column>
                                                    <el-table-column label="Relationship type" sortable
                                                        prop="RelationType">
                                                        <div class="d-flex" slot-scope="scope"
                                                            v-html="scope.row.RelationType"></div>
                                                    </el-table-column>
                                                    <el-table-column label="Photograph" sortable prop="Photograph">
                                                        <div class="d-flex" slot-scope="scope">
                                                            <!--<img height="70px" width="70px"  :src="getPhoto(scope.row.Photograph)" alt="">-->
                                                            <img height="70px" width="70px"
                                                                :src="'data:image/*;base64,' + scope.row.BasePhotograph"
                                                                alt="">

                                                        </div>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </div>
                                    </div>
                                    <el-dialog :visible.sync="modalVisible" title="Add Approver Details">
                                        <form @submit.prevent="saveApproverDetails">

                                            <div class="mb-3">
                                                <base-input :label="lang.label.groups" name="Groups">
                                                    <el-select v-model="changedDepartmentName" autocomplete="off"
                                                        :placeholder="lang.label.selectGroup" filterable>
                                                        <el-option v-for="(option, index) in departmentList"
                                                            :key="index" :label="option.name"
                                                            :value="option.id"></el-option>
                                                    </el-select>
                                                </base-input>
                                            </div>

                                            <div class="d-flex justify-content-end">
                                                <button type="button" class="btn btn-secondary me-2"
                                                    @click="modalVisible = false">Cancel</button>
                                                <button type="submit" class="btn btn-primary">Save</button>
                                            </div>
                                        </form>
                                    </el-dialog>
                                    <el-dialog :visible.sync="rejectModalVisible" title="Rejection Reason">
                                        <form @submit.prevent="onSubmit(10)">
                                            <div class="mb-3">
                                                <base-input :label="lang.label.rejectionReason" name="rejection_reason"
                                                    rules="required">
                                                    <el-input v-model="rejectionReason" type="textarea" :rows="3"
                                                        :placeholder="lang.label.enterRejectionReason"></el-input>
                                                </base-input>
                                            </div>

                                            <div class="d-flex justify-content-end">
                                                <button type="button" class="btn btn-secondary me-2"
                                                    @click="rejectModalVisible = false">
                                                    Cancel
                                                </button>
                                                <button type="submit" class="btn btn-danger" @click="onSubmit(10)">
                                                    Reject
                                                </button>
                                            </div>
                                        </form>
                                    </el-dialog>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option, Dialog } from "element-ui";
import clientPaginationMixin from "../../Tables/PaginatedTables/clientPaginationMixin";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import Notfound from "@/views/GeneralViews/NotFoundPage.vue";
var moment = require('moment');
import Alert from "@/components/BaseAlert.vue";
import state from "../../../store/state";
import ExportView from '@/components/ExportView.vue';

export default {
    mixins: [clientPaginationMixin],
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        'el-dialog': Dialog,
        [TableColumn.name]: TableColumn,
        RouteBreadCrumb,
        Notfound,
        Alert, ExportView
    },
    data() {
        return {
            approved: '',
            groupName: '',
            tableData: [],
            ID: this.$route.params.id,
            loading: true,
            errored: false,
            lang: this.$lang.visitor_request,
            data: {},
            questionAnswers: [],
            actions: [
                { text: 'Accept', value: 'first' },
                { text: 'Decline', value: 'second' }
            ],
            alertType: 'danger',
            successType: 'success',
            alertMessages: [],
            successMessages: [],
            status: "",
            siteRemarks: "",
            modalVisible: false,
            changedDepartmentName: "",
            departmentList: [],
            rejectModalVisible: false,
            rejectionReason: '',
        };
    },
    mounted() {
        this.loading = true;
        this.visitorDetails();
    },
    methods: {
        saveApproverDetails() {
            // let self = this;
            this.loading = true;
            let data = {
                "id": this.ID,
                "department": { department: this.changedDepartmentName },
            };
            this.$store.dispatch('reRouteApi', data)
                .then(response => {
                    if (response.status == 200) {
                        this.loading = false;
                        console.log(response.data);
                        // this.data.department.name = this.changedDepartmentName;
                        this.$router.push({ name: "visitorRequestApproval" });
                    } else {
                        if (response.status == 404) {
                            this.errored = true;
                        } else {
                            if (typeof response.data.message != 'object') {
                                this.alertMessages.push(response.data.message);
                            } else {
                                let array = new Array();
                                for (let key of Object.keys(response.data.message)) {
                                    let obj = response.data.message[key][0].includes('field') ? (key + "- " + response.data.message[key][0]) : response.data.message[key];
                                    array.push(obj)
                                }
                                this.alertMessages.push(array.join(', '));
                                setTimeout(function () {
                                    self.alertMessages = [];
                                }, 5000)
                            }
                        }
                        this.loading = false;
                    }

                })
                .catch(error => {
                    this.loading = false;
                })

        },
        openDocument(document) {
            if (!document) {
                this.$notify({
                    title: 'Warning',
                    message: 'No document available for preview',
                    type: 'warning'
                });
                return;
            }
            window.open(state.mediaURL + document, '_blank');

        },
        getPhoto(url) {
            return state.mediaURL + url;
        },
        onSubmit(status) {
            let self = this;
            this.loading = true;
            let data = {
                "id": this.ID,
                "SiteRemarks": this.siteRemarks,
                "Status": status,
                "rejection_reason": this.rejectionReason
            };
            this.$store.dispatch('updateCompanyVisitor', data)
                .then(response => {
                    if (response.status == 200) {
                        this.$store.commit('setDisqualified', response.data.message);
                        this.loading = false;
                        this.$router.push({ name: "visitorRequestApproval" });
                    } else {
                        if (response.status == 404) {
                            this.errored = true;
                        } else {
                            if (typeof response.data.message != 'object') {
                                this.alertMessages.push(response.data.message);
                            } else {
                                let array = new Array();
                                for (let key of Object.keys(response.data.message)) {
                                    let obj = response.data.message[key][0].includes('field') ? (key + "- " + response.data.message[key][0]) : response.data.message[key];
                                    array.push(obj)
                                }
                                this.alertMessages.push(array.join(', '));
                                setTimeout(function () {
                                    self.alertMessages = [];
                                }, 5000)
                            }
                        }
                        this.loading = false;
                    }

                })
                .catch(error => {
                    this.loading = false;
                })

        },
        visitorDetails() {
            let self = this;
            let id = this.ID;
            this.$store.dispatch('viewCompanyVisitorForms', id)
                .then(response => {
                    if (response.status == 200) {
                        this.approved = response.data.editable;
                        if (response.data.Members.length) {
                            this.groupName = response.data.Members[0].GroupName;
                        }
                        this.tableData = response.data.Members;
                        this.data = response.data;
                        this.siteRemarks = response.data.SiteRemarks;
                        this.questionAnswers = response.data.Answers;
                        this.departmentList = response.data.site.departments
                        this.changedDepartmentName = { ...response.data.department } ? { ...response.data.department }.name : '';
                        this.loading = false;
                    } else {
                        if (response.status == 404) {
                            this.errored = true;
                        } else {
                            if (typeof response.data.message != 'object') {
                                this.alertMessages.push(response.data.message);
                            } else {
                                let array = new Array();
                                for (let key of Object.keys(response.data.message)) {
                                    let obj = response.data.message[key][0].includes('field') ? (key + "- " + response.data.message[key][0]) : response.data.message[key];
                                    array.push(obj)
                                }
                                this.alertMessages.push(array.join(', '));
                                setTimeout(function () {
                                    self.alertMessages = [];
                                }, 5000)
                            }
                        }
                        this.loading = false;
                    }
                }).catch(error => {
                    this.loading = false;
                }).finally(() => this.loading = false)
        },
        formatFromdate(date) {
            return moment(date).format('DD/MM/YYYY HH:mm');
        },
        formatTodate(date) {
            return moment(date).format('DD/MM/YYYY HH:mm');
        },
        acceptVisitorRequest(status) {
            this.status = status;
            // this.onSubmit(status);

        },
        declineVisitorRequest(status) {
            this.status = status;
            // this.onSubmit(status);
        },
        printWindow: function () {
            window.print();

            //                var mediaQueryList = window.matchMedia(' (min-width: 900px) ');
            //                console.log('hi',mediaQueryList);
            ////                mediaQueryList.addListener(function (mql) {
            ////                    console.log('mql',mql);
            //                    if (mediaQueryList.matches) {
            //                        window.print();
            //                    } else {
            //                    }
            //                });
        },
        showRejectModal() {
            this.rejectModalVisible = true;
        },
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}

.modal-header {
    padding-bottom: 0;
}

.el-table__header,
.el-table__body {
    width: 100% !important;
}

colgroup {
    display: none !important;
}

@media print {
    .do-not-print {
        display: none;
    }
}

.documents-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1.25rem;
    padding: 0.5rem;
}

.document-item {
    background: #ffffff;
    border-radius: 10px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.document-item:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.document-card {
    padding: 1.25rem;
    display: flex;
    align-items: center;
    border: 1px solid #edf2f7;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
}

.document-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: #5e72e4;
    border-radius: 4px 0 0 4px;
}

.document-icon {
    font-size: 1.75rem;
    margin-right: 1.25rem;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fe;
    border-radius: 12px;
    transition: all 0.3s ease;
}

.document-details {
    flex: 1;
}

.document-name {
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
    line-height: 1.4;
}

.document-type {
    font-size: 0.75rem;
    color: #718096;
    font-weight: 500;
    margin-left: 0.5rem;
    text-transform: uppercase;
}

.document-actions {
    margin-top: 0.5rem;
}

.document-actions .btn {
    padding: 0.2rem 0.5rem;
    border-radius: 6px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .documents-container {
        grid-template-columns: 1fr;
    }

    .document-card {
        padding: 1rem;
    }

    .document-icon {
        width: 40px;
        height: 40px;
        font-size: 1.5rem;
    }
}
</style>
